export default __webpack_public_path__ + "1e827d29289ab0bf8deef470dfdf97e5.png";